import { DBInput } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";
import "./REDInput.css";

type REDInputProps = ComponentProps<typeof DBInput> & {
    /**
     * Keep error text in small size.
     * Default: false (error text will be displayed in normal/larger size)
     */
    keepSmallErrorText?: boolean;
};

const REDInput: React.FC<REDInputProps> = (props) => {
    const { keepSmallErrorText, ...dbInputProps } = props;

    // Apply wrapper class when we want normal-sized error text (default behavior)
    const wrapperClass = keepSmallErrorText !== true ? "red-input-normal-error" : "";

    return (
        <div className={wrapperClass}>
            <DBInput {...dbInputProps}>{props.children}</DBInput>
        </div>
    );
};

export default REDInput;